import type { FaireProductEntity } from "../../entity_types/product";

export const p_hwzn7xv6z3: FaireProductEntity = {
  token: "p_hwzn7xv6z3",
  type: "product",
  name: "OkLoveYouBye Set of Two Stitched Notebooks Journals",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/879347740d99de38fbbc4c8fbf1dbb5091183e7d18ea02e9582f15c5f13d303c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1d44493b2426f391fd8f5892d7c0ae800d52824b2d03c401ea62baaf10d47c6c.jpeg",
    "https://cdn.faire.com/fastly/8c60a5cdf00dd1c6852c6b15a5de2c68f9bc58ad8df797443e7e798fdc9a21d2.jpeg",
    "https://cdn.faire.com/fastly/3a90d679b6236e95048e60501e154a5ceb02cb92676892ce12ea88deaad31f38.jpeg",
    "https://cdn.faire.com/fastly/01ebc3c9d66c37b47b56c73dd1435978f10ed2e89aff9834a43017743b9ed5ae.jpeg",
    "https://cdn.faire.com/fastly/84453b364b7103a3d0082a3f7cc28a0efd41590dfa5aa9a1aa18de1067c39e3d.png",
  ],
  priceDollars: 8,
  description:
    "Who among us does not have an entire ocean of thoughts floating around in our heads? Nobody! A notebook is the perfect way to calm the cranial seas... simply write things down. And this set of 2 gives you so many options—make one messy, one clean. One to remember, one to forget. Likes, dislikes. Business in the front, party in the back. Have fun seeing what your thought waves will come up with.",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:54.145Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
